import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Typography, Card, Table, Row, Spin, Col, Form, Input, Space, Button } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import ModalJournalEntry from "./components/ModalJournalEntry";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Entry ID",
    dataIndex: "entryId",
  },

  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Account",
    dataIndex: "account",
  },
  {
    title: "Debit",
    dataIndex: "debit",
  },
  {
    title: "Cedit",
    dataIndex: "credit",
  },
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const ViewGLA0200 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const { months, viewJournalEntryItems, monthList } = appStatic;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const [journalEntryDetail, setJournalEntryDetail] = useState([]);
  const [modalDetail, setModalDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailJournalEntry}=${params.transactionId}${params?.transactionUniqueId?.length > 2 ? "&transactionUniqueId=" + params.transactionUniqueId : ""}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res.pageItems;
        setJournalEntryDetail(objDetail[0]);
        console.log(objDetail[0]);

        let tempArray = [];

        objDetail.forEach((element) => {
          tempArray.push({
            key: element?.id,
            entryId: element?.id ? element?.id : "No ID",
            branch: element?.officeName ? element?.officeName : "No Branch",
            transactionDate: element?.transactionDate
              ? `${element?.transactionDate[2]} ${
                  monthList[element?.transactionDate[1] - 1]
                } ${element?.transactionDate[0]}`
              : "No transaction Date",
            transactionId: element?.transactionId ? element?.transactionId : "No Transaction ID",
            type: element?.glAccountType?.value ? element?.glAccountType?.value : "No Type",
            createdBy: element?.createdByUserName ? element?.createdByUserName : "No User Name",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "No short local currency",
            debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
            credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
          });
        });
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);

        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    setModalDetail(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      // navigate("/view-gla0200", { state: selectedRow });
      // console.log("viewing");
      showModal();
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = "finance rule";
    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.DeleteFinaceRules}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteFinanceRuleMsg);
              navigate("/gla0300");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/view-gla0200");
              setIsLoading(false);
            },
          },
        );
      },
      function () {
        // No button
      },
    );
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      cnt.RIGHT_DETAIL_BTN,
      //  cnt.RIGHT_EDIT_BTN
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const onUndoTransaction = (key) => {
    const formValues = {};

    console.log();

    formValues.transactionAmount = key?.amount;
    formValues.transactionDate = BOM.DateTime(key.date, "only-date");
    formValues.dateFormat = "dd MMMM yyyy";

    let action = "Reverse ";
    let label = "Transaction";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const params = {
          command: "reverse",
        };
        const url = `${definedApi.NewJournalEntries}/${key.transactionId}`;

        const body = {
          method: "POST",
          locale: "en",
          comments: "Reverse",
          // ...formValues,
          session,
          params,
        };

        // message.warning(
        //   "Close or Re-Open module is not ready require some works from the backend"
        // );
        // return;
        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, appLabel.undoTransactionMsg);

              // Close modal
              setIsModalOpen(false);

              // Update local state to reflect the reversal
              setJournalEntryDetail((prevDetail) => ({
                ...prevDetail,
                reversed: true,
              }));

              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/view-gla0200");
              setIsLoading(false);
            },
          },
        );
      },
      function () {
        // No button
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={appLabel.viewJournalEntryDetail} pageItems={viewJournalEntryItems} />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Card
          style={{
            marginBottom: "3%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row>
              <Title level={3}>
                {`${appLabel.transactionNumber} - ${
                  journalEntryDetail.transactionId
                    ? journalEntryDetail.transactionId
                    : "Transaction ID"
                }`}
              </Title>

              {BOM.HasPermission("REVERSE_JOURNALENTRY") && (
                <Space
                  size="small"
                  style={{
                    marginLeft: "auto",
                  }}
                >
                  {typeof journalEntryDetail.reversed !== "undefined" && (
                    <>
                      {journalEntryDetail.reversed ? (
                        <Text type="danger" style={{ fontWeight: "bold", marginLeft: 8 }}>
                          This transaction was reversed
                        </Text>
                      ) : (
                        <Button
                          type="primary"
                          shape="round"
                          className="of-primaryBtnColor"
                          onClick={() => onUndoTransaction(journalEntryDetail)}
                          danger
                        >
                          Reverse
                        </Button>
                      )}
                    </>
                  )}
                </Space>
              )}
            </Row>
          }
        >
          <Card
            style={{
              marginBottom: "2%",
              boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
          >
            <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
              <Card
                style={{
                  marginBottom: "2%",
                  boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                  // borderRadius: 20,
                }}
              >
                <Row style={{ justifyContent: "space-between" }}>
                  <Form.Item label={<Text strong>{appLabel.branch}</Text>}>
                    <Input
                      style={{ width: "30vh", fontWeight: "bold" }}
                      disabled
                      value={journalEntryDetail.officeName}
                    />
                  </Form.Item>
                  <Form.Item label={<Text strong>{appLabel.transactionDate}</Text>}>
                    <Input
                      style={{ width: "30vh", fontWeight: "bold" }}
                      disabled
                      value={
                        journalEntryDetail?.transactionDate
                          ? `${journalEntryDetail?.transactionDate[2]} ${
                              monthList[journalEntryDetail?.transactionDate[1] - 1]
                            } ${journalEntryDetail?.transactionDate[0]}`
                          : "-"
                      }
                    />
                  </Form.Item>
                  <Form.Item label={<Text strong>{appLabel.createdBy}</Text>}>
                    <Input
                      style={{ width: "30vh", fontWeight: "bold" }}
                      disabled
                      value={journalEntryDetail.createdByUserName}
                    />
                  </Form.Item>
                  <Form.Item label={<Text strong>{appLabel.createdOn}</Text>}>
                    <Input
                      style={{ width: "30vh", fontWeight: "bold" }}
                      disabled
                      value={
                        journalEntryDetail?.createdDate
                          ? `${journalEntryDetail?.createdDate[2]} ${
                              monthList[journalEntryDetail?.createdDate[1] - 1]
                            } ${journalEntryDetail?.createdDate[0]}`
                          : "-"
                      }
                    />
                  </Form.Item>
                </Row>

                {/* <Row style={{ justifyContent: "space-between" }}> */}

                {/* </Row> */}
              </Card>
            </Form>
            {/* ACCOUNT CLOSURE TABLE SECTION */}
            <Table
              rowSelection={{
                type: "radio",
                ...rowSelection,
                onChange: onSelectItemAction,
              }}
              columns={columns}
              dataSource={journalEntryList}
              bordered
              //   title={() => "Customers List"}
              pagination={{
                position: "bottomCentre",
                pageSize: tableCount,
              }}
            />
          </Card>

          {/*Modal Section */}
          <ModalJournalEntry
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            modalDetail={modalDetail}
            journalEntryDetail={journalEntryDetail}
          />
        </Card>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0200);
